import moonscript from "refractor/moonscript";
export default moonscript;